import { ReactNode } from "react";
import { TableCell, TableRow } from "@mui/material";
import { twMerge } from "tailwind-merge";

type TableGroupRowProps = {
  colSpan: number;
  rowClassName?: string;
  cellClassName?: string;
  children: ReactNode;
};

export const TableGroupRow = ({
  colSpan,
  rowClassName,
  cellClassName,
  children,
}: TableGroupRowProps) => (
  <TableRow className={twMerge("bg-gray-50 font-semibold", rowClassName)}>
    <TableCell colSpan={colSpan} className={twMerge("px-4 py-3", cellClassName)}>
      {children}
    </TableCell>
  </TableRow>
);
